<template>
  <el-card class="">
    <el-page-header @back="goBack" content="日报详情"></el-page-header>
    <div class="daily-content">
      <div class="content">
        <div class="item" :class="{ disabled: currentIndex === 0 }" @click="prev">
          <i class="el-icon-arrow-left"></i>
        </div>
        <iframe id="iframe-id" class="iframe" v-if="dailyId" :src="dailySrc"></iframe>
        <div class="item" :class="{ disabled: currentIndex === items.length - 1 }" @click="next">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'AddMaintenanceDay',
  data () {
    return {
      items: [],
      currentIndex: 0
    }
  },
  computed: {
    // dailyId = ''
    dailyId () {
      return this.$route.query.dailyId
    },

    projectId () {
      return this.$route.query.projectId
    },

    dailySrc () {
      const target = decodeURIComponent('/pagesA/pages/curingdaily/dailydetail?dailyId=' + this.dailyId)
      if (process.env.NODE_ENV !== 'production') {
        return 'http://localhost:8100/apph5/#/pages/loading/loading?redirectUrl=' + target
      } else {
        return '/apph5/#/pages/loading/loading?redirectUrl=' + target
      }
    }
  },

  created () {
    // do something with
    // this.dailyId = this.$route.query.dailyId as string
    this.loadData()
  },

  mounted () {
    // this.getConserveEchars(10, 15)
    window.addEventListener('popstate', this.handlePopState)
  },

  beforeDestroy () {
    window.removeEventListener('popstate', this.handlePopState)
  },

  methods: {
    loadData () {
      this.$axios.get(this.$apis.maintenanceDaily.selectYhProjectDailyByPage, {
        projectId: this.projectId
      }).then((res) => {
        this.items = res.list || []
        this.currentIndex = this.items.findIndex((item) => item.dailyId === this.dailyId)
      })
    },

    handlePopState () {
    // 在这里处理 iframe 的显示状态
    // 可以根据需要，隐藏或加载 iframe
    // 示例：隐藏 iframe
      console.log('iframe-id')
      const iframe = document.getElementById('iframe-id')
      if (iframe) {
        iframe.style.display = 'none'
      }
    },

    prev () {
      this.currentIndex--
      this.toDetail()
    },

    next () {
      this.currentIndex++
      this.toDetail()
    },

    toDetail () {
      const dailyId = this.items[this.currentIndex].dailyId
      // this.dailyId = dailyId
      this.$router.replace(`/maintenanceDaily/details?dailyId=${dailyId}&projectId=${this.projectId}`)
    },

    goBack () {
      this.$router.replace('/maintenanceDaily')
    }
  }
}
</script>

<style scoped lang="scss">
.iframe {
  width: 375px;
  height: 667px;

  border: 4px solid rgba(0, 0, 0, 0.7);
  border-radius: 16px;
  margin: 0 20px;
  display: flex;
}

.daily-content {
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    display: flex;
    align-items: center;
  }

  .item {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(204, 204, 204, 0.5);
    border-radius: 50%;
    cursor: pointer;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &:hover {
      opacity: 0.7;
    }

    i {
      font-size: 30px;
    }
  }
}
</style>
